let loading = {
    loader: false
}
const Loader = (isLoad) => {
    return loading.loader = isLoad;
}

export default Loader;